import * as angular from 'angular';

import { ResponseNavComponent } from './responseNav.component';
import ResponseNavJspxWrapperController from './responseNavJspxWrapper.controller';
import ResponseNavSubmitResponseModalService from './responseNavSubmitResponseModal.service';
import ResponseNavSubmitOffersModalService from './responseNavSubmitOffersModal.service';
import LayoutModule from '../layout/layout.module';
import UtilModule from '../util/util.module';
import { HomeNavComponent } from './homeNav.component';
import { ApplicationRoutesNgService } from '../routeGuard/applicationRoutesNg.service';
import SellerResponseService from '../../sellerResponse/common/sellerResponse.service';

// Used by the seller side response pages
// TODO: Import angular strap
export default angular
  .module('CrossPageNavigation', ['mgcrea.ngStrap', UtilModule, LayoutModule])
  .service('ApplicationRoutesNgService', ApplicationRoutesNgService)
  .service('SellerResponse', SellerResponseService)
  .component('responseNav', ResponseNavComponent)
  .component('homeNav', HomeNavComponent)
  .controller(
    'ResponseNavJspxWrapperController',
    ResponseNavJspxWrapperController,
  )
  .service(
    'ResponseNavSubmitOffersModal',
    ResponseNavSubmitOffersModalService,
  )
  .service(
    'ResponseNavSubmitResponseModal',
    ResponseNavSubmitResponseModalService,
  ).name;
